import { ReportScreen } from "@/features/report-screen";

/** The line report (ADR-074 in platform): how callers were served, line by line. Its screen is `features/report-screen.tsx`, shared with
 *  the other two reports. */
export function LineReportPage() {
  return <ReportScreen kind="lines" />;
}
